import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Issuer } from '../../types/paymentMethod.types';

interface IssuerState {
  issuer: Issuer | null;
}

const initialState: IssuerState = {
  issuer: null,
};

const issuerSlice = createSlice({
  name: 'issuer',
  initialState,
  reducers: {
    setIssuer: (state: IssuerState, action: PayloadAction<Issuer>) => {
      state.issuer = action.payload;
    },
    resetIssuer: (state: IssuerState) => {
      state.issuer = null;
    },
  },
});

const { reducer } = issuerSlice;

export const { resetIssuer, setIssuer } = issuerSlice.actions;

export default reducer;
